import { motion, useReducedMotion } from "framer-motion"
import type { ReactNode } from "react"

type Tab = {
  id: string
  label: string
  icon?: ReactNode
}

type TabsProps = {
  tabs: Tab[]
  activeId: string
  onChange: (id: string) => void
}

export function Tabs({ tabs, activeId, onChange }: TabsProps) {
  const shouldReduce = useReducedMotion()

  return (
    <div
      role="tablist"
      className="mono"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "18px",
        position: "relative",
        width: "100%",
      }}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeId
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className="mono"
            style={{
              position: "relative",
              padding: "12px 4px",
              minHeight: "44px",
              background: "transparent",
              border: "none",
              color: isActive ? "var(--text)" : "var(--muted)",
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              cursor: "pointer",
              flexShrink: 0,
              scrollSnapAlign: "center",
            }}
          >
            <span style={{ display: "inline-flex", gap: "8px", alignItems: "center" }}>
              {tab.icon}
              {tab.label}
            </span>
            {isActive ? (
              <motion.span
                layoutId="tab-underline"
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 0,
                  height: "2px",
                  background: "var(--rail)",
                  transformOrigin: "left",
                }}
                transition={shouldReduce ? { duration: 0 } : { duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
              />
            ) : null}
          </button>
        )
      })}
    </div>
  )
}

export default Tabs
